import { Dispatch, SetStateAction } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface LeftOffDialogProps {
  setLeftOffUrl: Dispatch<SetStateAction<string | undefined>>;
  leftOffUrl: string | undefined;
  onStartAgain: () => void;
}

const LeftOffDialog = ({ setLeftOffUrl, leftOffUrl, onStartAgain }: LeftOffDialogProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToLeftOff = () => {
    if (leftOffUrl) {
      // Preserve URL search parameters when continuing where left off
      const searchParams = location.search;
      navigate(`${leftOffUrl}${searchParams}`);
    }
  };

  const startAgain = () => {
    if (!leftOffUrl) return;
    setLeftOffUrl(undefined);
    onStartAgain();
  };

  return (
    <div>
      <button className="bg-yellow-500 text-black 	p-2	uppercase rounded-lg font-semibold text-md" type="button" onClick={navigateToLeftOff}>
        Continue where you left off
      </button>
      <div className="p-4">or </div>
      <button className="bg-yellow-500 text-black 	p-2	uppercase rounded-lg font-semibold text-md" type="button" onClick={startAgain}>
        Start again
      </button>
    </div>
  );
};

export { LeftOffDialog };
